import { connect } from 'react-redux'
import AcgFlow from './AcgFlow'

const mapDispatchToProps = () => ({
})

const mapStateToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(AcgFlow)
